import { useReveal } from "@/hooks/useReveal";

const STATS = ["15% fat", "No added sugar", "Certificate of analysis per batch"];

export default function Cocoa() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="cocoa" className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div
          ref={ref}
          className="reveal grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14 items-center"
        >
          <div className="w-full">
            <img
              src="https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/3040efbc-526f-4d0c-93bb-4ea71a83b09a_compressed_chocolate-behind-the-counter.webp"
              alt="Hot chocolate being poured into a ceramic cup with a dusting of cocoa powder"
              loading="lazy"
              className="w-full h-[280px] md:h-[460px] object-cover object-top rounded-lg"
            />
          </div>

          <div>
            <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold leading-tight">
              And the hot chocolate behind the counter
            </h2>
            <p className="mt-5 text-ink/70 text-[17px] leading-relaxed">
              Pure organic cocoa powder at 15% fat, no added sugar, with a
              stable specification batch to batch — so the drink your Sandton
              site serves is the drink your Cape Town site serves. It works as
              a base for hot chocolate, mochas, dusting and bakery, and it
              comes from the same production run and the same container as the
              sachets, which means one order and one supplier for both.
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-3">
              {STATS.map((stat) => (
                <div
                  key={stat}
                  className="border border-cream-dark/60 rounded-lg px-4 py-3 text-center"
                >
                  <span className="text-ink font-serif text-base md:text-lg font-semibold">
                    {stat}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}